import { cloudChiprApi } from "../../../../../../services/cloudchipr.api";

export const costBreakdownV2WidgetSetupSelector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentWidgetsCostBreakdown
    .select;
